"use client";

import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function HeroBookingBanner() {
  return <section data-section-id="2838" id="herobookingbanner" className="relative min-h-[90vh] w-full overflow-hidden bg-[#1A1A1A] text-white flex items-center justify-center animate-reveal">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://phoenixlimo.info/wp-content/uploads/2026/06/ChatGPT-Image-Jun-26-2026-05_54_07-AM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/profile pic.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/profile pic.png-wvc-sizes" alt="Luxury black car service in Los Angeles" className="h-full w-full object-cover opacity-70" loading="lazy" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1A1A1A]/30 via-transparent to-[#1A1A1A]/60" />
      </div>

      {}

      {}
      

      {}
      <div className="absolute bottom-12 right-8 z-20 hidden md:flex md:right-12 lg:right-16">
        <div className="flex flex-col items-center gap-4">
          <span className="font-sans text-xs tracking-[0.3em] uppercase [writing-mode:vertical-rl] rotate-180" style={{
          color: "hsla(45, 85%, 55%, 0.8)"
        }}>
            Scroll — PHOENIX
          </span>
          <div className="relative h-20 w-px overflow-hidden" style={{
          backgroundColor: "hsla(45, 85%, 55%, 0.8)"
        }}>
            <div className="absolute top-0 left-0 w-full animate-scroll-line" style={{
            height: "40%",
            background: "linear-gradient(to bottom, transparent, hsl(45, 85%, 55%), transparent)"
          }} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scroll-line {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(250%); }
        }
        .animate-scroll-line {
          animation: scroll-line 2s ease-in-out infinite;
        }
      `}</style>
    </section>;
}